/* 🤖 this file was generated by svg-to-ts*/
export const icoCrossCheckDuo: {
  name: 'cross-check-duo';
  data: string;
} = {
  name: 'cross-check-duo',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path opacity="0.12" d="M11.9001 21.8002C17.3678 21.8002 21.8002 17.3678 21.8002 11.9001C21.8002 6.43243 17.3678 2 11.9001 2C6.43243 2 2 6.43243 2 11.9001C2 17.3678 6.43243 21.8002 11.9001 21.8002Z" fill="#5EBD3C"/>
  <path d="M12 22C6.49 22 2 17.51 2 12C2 6.49 6.49 2 12 2C17.51 2 22 6.49 22 12C22 17.51 17.51 22 12 22ZM12 4C7.58 4 4 7.58 4 12C4 16.42 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4Z" fill="#5EBD3C"/>
  <path d="M10.5067 16C10.2479 16 9.999 15.8938 9.7999 15.692L7.29119 13.0156C6.90294 12.6014 6.90294 11.9323 7.29119 11.5181C7.67944 11.1039 8.30662 11.1039 8.69487 11.5181L10.4968 13.4404L15.3051 8.31065C15.6934 7.89645 16.3206 7.89645 16.7088 8.31065C17.0971 8.72486 17.0971 9.39396 16.7088 9.80816L11.1936 15.692C10.9945 15.9044 10.7456 16 10.4868 16H10.5067Z" fill="#5EBD3C"/>
</svg>`
};
